import type { Stage } from '../domain/stages'
import { createStore, useStore } from './store'

/**
 * Which stage the phone's pipeline shows, and the row to point out.
 *
 * Coming back from an idea lands on the stage it is in now, with its row lit
 * for a moment: an idea moved to Filming from its page is found in Filming,
 * rather than having vanished from the list it was opened from.
 */
export const stageViewStore = createStore<{ stage: Stage; flash: number | null }>({
  stage: 'ideas',
  flash: null,
})

export const useStageView = () => useStore(stageViewStore)
